import {useTranslation, Trans} from "react-i18next";
import React, {useState, useEffect} from "react";
import {httpPost, httpGet} from "../shared/Config";
import InputText from "../shared/InputText";
import InputSelect from "../shared/InputSelect";

const defaultData = {
    name: '',
    rfc: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    postalCode: '',
    cfdiId: '',
    regimenFiscal: ''
}

export default function VerifySignupEmail({
    documents, verifications, whatsapp, productName, currency
                                          }) {


    const {t} = useTranslation();

    const [email, setEmail] = useState('')
    const [working, setWorking] = useState(false);
    const [userExists, setUserExists] = useState(false);
    const [facturar, setFacturar] = useState(false);
    const [facturacionData, setFacturacionData] = useState(defaultData);

    const [regimenFiscalesSelect, setRegimenFiscalesSelect] = useState();
    const [cfdiSelect, setCfdiSelect] = useState();

    function handleEmailChange(e) {
        setEmail(e.target.value)
    }

    function facturarChange(e) {
        setFacturar(Boolean(e.target.checked));
    }

    function handleTextChange(attr) {
        return function(event) {
            if(attr !== "cfdi") {
                setFacturacionData({...facturacionData, [attr]:event.target.value})
            } else {
                setFacturacionData({...facturacionData, [attr]:event.target.value, regimenFiscal: ""})
            }
        }
    }

    useEffect(() => {
        async function getCFDIs() {
            try {
                const response = await httpGet(`/getCFDIs`);
                setCfdiSelect(response.data.map((cfdiId) => <option key={cfdiId.id} value={cfdiId.code}>{cfdiId.desc}</option>));
            } catch(e) {
            }

        }
        getCFDIs();
    }, [])

    useEffect(() => {
        async function fetchRegimenFiscales() {
            try {
                let code = "";
                if(facturacionData.cfdiId?.code) {
                    code = facturacionData.cfdiId?.code
                } else {
                    code = facturacionData.cfdiId;
                }

                debugger
                const response = await httpGet(`/getRegimenFiscales/${code}`);
                setRegimenFiscalesSelect(response.data.map((regimenFiscal) => <option key={regimenFiscal.id} value={regimenFiscal.code}>{regimenFiscal.data}</option>));
            } catch(e) {
            }
        }
        if(facturacionData.cfdiId) {
            fetchRegimenFiscales();
        }
    }, [facturacionData.cfdiId])

    async function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        try {
            setUserExists(false);
            setWorking(true);
            const res = await httpPost('/subscriptions/preRegister', {
                email,
                productName,
                whatsAppMessages:whatsapp,
                documents,
                verifications,
                currency: currency,
                facturar,
                facturarInfo: facturacionData
            })
            if (res.data.checkoutUrl) {
                window.location.href = res.data.checkoutUrl;
                return;
            }
        } catch(e) {
            if(e?.response?.data?.error === 'user already exists') {
                setUserExists(true)
            }
            setWorking(false);
        } finally {
        }
    }

    return (
            <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
                <fieldset className="fieldset">
                    <label className="label cursor-pointer">
                        {t('FACTURAR')}
                        <input type="checkbox" className="checkbox checkbox-primary"
                            onChange={(e) => facturarChange(e)}
                            value={facturar} 
                            checked={facturar}
                        />{' '}
                    </label>
                </fieldset>
                {
                    facturar ? <React.Fragment>
                        <div className="ring-1 ring-blue-400 rounded-xl py-8 px-8">
                            <InputText
                                disabled={working}
                                value={facturacionData.name}
                                onChange={handleTextChange('name')}
                                required>
                                {t('COMPANY_NAME')}
                            </InputText>
                            <InputText
                                disabled={working}
                                value={facturacionData.rfc}
                                onChange={handleTextChange('rfc')}
                                required>
                                {t('RFC')}
                            </InputText>                    
                            <InputText
                                disabled={working}
                                value={facturacionData.contactName}
                                onChange={handleTextChange('contactName')}
                                required>
                                {t('NAME')}
                            </InputText>
                            <InputText
                                disabled={working}
                                type={'email'}
                                value={facturacionData.contactEmail}
                                onChange={handleTextChange('contactEmail')}
                                required>
                                {t('EMAIL')}
                            </InputText>
                            <InputText
                                type="number"
                                disabled={working}
                                value={facturacionData.contactPhone}
                                onChange={handleTextChange('contactPhone')}
                                required>
                                {t('PHONE')}
                            </InputText>
                            <InputText
                                type="number"
                                disabled={working}
                                value={facturacionData.postalCode}
                                onChange={handleTextChange('postalCode')}
                                required>
                                {t('POSTAL_CODE')}
                            </InputText>
                            <InputSelect
                                disabled={working}
                                label={t('CFDI_USE')}
                                value={facturacionData.cfdiId.code}
                                onChange={handleTextChange('cfdiId')}
                                required>
                                <option value=""></option>
                                {cfdiSelect}
                            </InputSelect>
                            <InputSelect
                                label={t('REGIMEN')}
                                disabled={working}
                                value={facturacionData.regimenFiscal.code}
                                onChange={handleTextChange('regimenFiscal')}
                                required>
                                <option value=""></option>
                                {regimenFiscalesSelect}
                            </InputSelect>
                        </div>
                    </React.Fragment> : null
                }
                <fieldset className="fieldset">
                    <span className="text-xs">{t('EMAIL_NOTICE_INFO')}</span>
                    <legend className="fieldset-legend">
                        {t('Enter your email')}
                    </legend>
                    <input type="email" className="input input-primary input-lg w-full"
                           onChange={handleEmailChange}
                           value={email}
                           required={true}
                    />
                </fieldset>
                { userExists &&
                    <p className="text-2xl mb-5">
                        {t('Signup account exists')}
                        <a className={'link'}
                           href={t('App link')}>
                            {t('App link')}
                        </a>
                    </p>
                }
                <button className="btn btn-primary btn-lg" type="submit" disabled={working}>
                    {t('Next')}
                </button>
            </form>
    )

}
